import './ContextMenuColumnList.c29c40b57818aefcf24a69893d8c354d.css';
export default {"column":"_column_qz5og_1"};